export default "__VITE_ASSET__6c2453ae__"